/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC } from 'react'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'

import { Marker } from '../../../components/elements'
import Constants from '../../../data/Constants.json'
import { SimulationBuildingBuildingInfo } from '@gateway.Simulation'
import { Tooltip } from '@progress/kendo-react-tooltip'
import dayjs from 'dayjs'

const codeNamesTopdown = Constants.topdownFlag
const codeNamesPresence = (buildingFlg: string | undefined) => {
  return Constants.presenceFlag.find(
    (codeName) => codeName.code === buildingFlg
  )?.name
}

export interface BuildingInformationCardProps {
  updStsKbn?: string | null
  paddingLeft?: number
  buildingInfo: SimulationBuildingBuildingInfo
  yamadumiAutoKbn?: string | null
}

export const BuildingInformationCard: FC<BuildingInformationCardProps> = React.memo(({
  updStsKbn,
  paddingLeft = 0,
  buildingInfo,
  yamadumiAutoKbn
}) => {
  const opportunityProgressColor = (opportunityProgressKbn: string | null) => {
    if (opportunityProgressKbn === '1' || opportunityProgressKbn === '4') {
      return 'primary'
    }
    if (opportunityProgressKbn === '2') {
      return 'secondary'
    }
    if (opportunityProgressKbn === '3') {
      return 'accent'
    }
  }
  return (
    <div style={{ paddingLeft }}>
      <Tooltip position='right'>
        <Card orientation="horizontal">
          <CardBody>
            <GridLayout gap={{ cols: 10 }}>
              <GridLayoutItem col={1}>
                <GridLayout>
                  <GridLayoutItem col={1} row={1}>
                    <span
                      style={{
                        fontSize: '1.5em',
                        fontWeight: 'bold',
                        color:
                          updStsKbn === '2' &&
                          buildingInfo.branchCdHistory !== null &&
                          buildingInfo.branchCdHistory !== undefined &&
                          buildingInfo.branchCd !== buildingInfo.branchCdHistory
                            ? '#D0611E'
                            : 'gray'
                      }}
                    >
                      {buildingInfo.branchNm ?? '\xa0'.repeat(1)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={2}>
                    <span
                      style={{
                        fontSize: '1em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      {buildingInfo.procurementNo ?? '\xa0'.repeat(1)}-
                      {buildingInfo.subNo ?? '\xa0'.repeat(3)}-
                      {buildingInfo.expenseSeq ?? '\xa0'.repeat(1)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={4}>
                    <span
                      style={{
                        fontSize: '1.5em',
                        fontWeight: 'bold',
                        color:
                          updStsKbn === '2' &&
                          buildingInfo.evaluationValueCdHistory !== null &&
                          buildingInfo.evaluationValueCdHistory !== undefined &&
                          buildingInfo.evaluationValueCd !== buildingInfo.evaluationValueCdHistory
                            ? '#D0611E'
                            : 'gray'
                      }}
                    >
                      {buildingInfo.evaluationValue ?? '\xa0'.repeat(1)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={5}>
                    <span
                      style={{
                        fontSize: '1.5em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      {'選択と集中：'}
                    </span>
                    <span
                      style={{
                        fontSize: '1.5em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      {codeNamesPresence(
                        buildingInfo?.choiceAndConcentrationTarget?.toString()
                      ) ?? '\xa0'.repeat(1)}{' '}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={6}>
                    <span
                      style={{
                        fontSize: '1.5em',
                        fontWeight: 'bold',
                        color: updStsKbn === '1' ? '#ff0000' : 'gray'
                      }}
                    >
                      {buildingInfo.updSts ?? '\xa0'.repeat(1)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={7}>
                    <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
                      <Marker
                        themeColor={opportunityProgressColor(
                          buildingInfo.opportunityProgressKbn
                        )}
                      >
                        {buildingInfo.opportunityProgress ?? '\xa0'.repeat(1)}
                        {buildingInfo.opportunityProgressKbn === '1' && yamadumiAutoKbn === '2' ? '（適正工期）' : ''}
                      </Marker>
                    </span>
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>

              <GridLayoutItem col={2} style={{ marginLeft: 10, marginRight: 10 }}>
                <GridLayout>
                  <GridLayoutItem
                    col={1}
                    colSpan={3}
                    row={1}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '1.0em'
                      }}
                      title={buildingInfo.construcionNm ?? ''}
                    >
                      {buildingInfo.construcionNm ?? '\xa0'.repeat(1)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={1}
                    colSpan={3}
                    row={2}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.procurementSts ?? '\xa0'.repeat(9)}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.obtainHistory ?? '\xa0'.repeat(9)}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.constructionForm ?? '\xa0'.repeat(6)}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.ourCompanyEquityRatio === null ? '\xa0'.repeat(9) : buildingInfo.ourCompanyEquityRatio?.toLocaleString() + '%'}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.effortLevel ?? '\xa0'.repeat(9)}{' '}
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em'
                      }}
                    >
                      コアトップ案件:
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                     {codeNamesPresence(
                       buildingInfo?.coreTopFlg?.toString()
                     ) ?? '\xa0'.repeat(6)}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.obtainFy ?? '\xa0'.repeat(6)}{' '}
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                      title={buildingInfo.prefecture ?? '\xa0'.repeat(9)}
                    >
                      {buildingInfo.prefecture ?? '\xa0'.repeat(9)}{' '}
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                      title={buildingInfo.city ?? '\xa0'.repeat(9)}
                    >
                      {buildingInfo.city ?? '\xa0'.repeat(9)}{' '}
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfo.constructionSubjectCd ?? '\xa0'.repeat(1)}{' '}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={1}
                    colSpan={3}
                    row={3}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      総工事金額（百万）:￥
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                      // title={buildingInfo.totalCost?.toLocaleString() ?? '\xa0'.repeat(6)}
                      title={
                        buildingInfo.totalCost !== null && buildingInfo.totalCost !== undefined
                          ? (buildingInfo.totalCost / 1000000).toLocaleString()
                          : '\xa0'.repeat(6)
                      }
                    >
                      {/* {buildingInfo.totalCost?.toLocaleString() ?? '\xa0'.repeat(6)}{' '} */}
                      {
                        buildingInfo.totalCost !== null && buildingInfo.totalCost !== undefined
                          ? (buildingInfo.totalCost / 1000000).toLocaleString()
                          : '\xa0'.repeat(6)
                      }
                    </span>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      当社概算工事金額（百万）:￥
                    </span>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                      // title={buildingInfo.ourCompanyTotalCost?.toLocaleString() ?? '\xa0'.repeat(6)}
                      title={
                        buildingInfo.ourCompanyTotalCost !== null && buildingInfo.ourCompanyTotalCost !== undefined
                          ? (buildingInfo.ourCompanyTotalCost / 1000000).toLocaleString()
                          : '\xa0'.repeat(6)
                      }
                    >
                      {/* {buildingInfo.ourCompanyTotalCost?.toLocaleString() ?? '\xa0'.repeat(6)} */}
                      {
                        buildingInfo.ourCompanyTotalCost !== null && buildingInfo.ourCompanyTotalCost !== undefined
                          ? (buildingInfo.ourCompanyTotalCost / 1000000).toLocaleString()
                          : '\xa0'.repeat(6)
                      }
                    </span>
                  </GridLayoutItem>
                  <>
                    <GridLayoutItem
                      col={1}
                      row={4}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        {buildingInfo.construcion ?? '\xa0'.repeat(9)}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.architectureUseHistory !== null &&
                            buildingInfo.architectureUseHistory !== undefined &&
                            buildingInfo.architectureUseCd !== buildingInfo.architectureUseHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {' '}
                        {buildingInfo.architectureUse ?? '\xa0'.repeat(9)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        （
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.structureUndergroundCdHistory !== null &&
                            buildingInfo.structureUndergroundCdHistory !== undefined &&
                            buildingInfo.structureUndergroundCd !== buildingInfo.structureUndergroundCdHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {buildingInfo.structureUnderground ?? '\xa0'.repeat(6)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        /
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.structureGroundCdHistory !== null &&
                            buildingInfo.structureGroundCdHistory !== undefined &&
                            buildingInfo.structureGroundCd !== buildingInfo.structureGroundCdHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {buildingInfo.structureGround ?? '\xa0'.repeat(6)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        ）
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.totalFloorAreaM2History !== null &&
                            buildingInfo.totalFloorAreaM2History !== undefined &&
                            buildingInfo.totalFloorAreaM2 !== buildingInfo.totalFloorAreaM2History
                              ? '#D0611E'
                              : ''
                        }}
                        title={buildingInfo.totalFloorAreaM2?.toLocaleString() ?? '\xa0'.repeat(9)}
                      >
                        {buildingInfo.totalFloorAreaM2?.toLocaleString() ?? '\xa0'.repeat(9)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        ㎡/
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.totalFloorAreaTsuboHistory !== null &&
                            buildingInfo.totalFloorAreaTsuboHistory !== undefined &&
                            buildingInfo.totalFloorAreaTsubo !== buildingInfo.totalFloorAreaTsuboHistory
                              ? '#D0611E'
                              : ''
                        }}
                        title={buildingInfo.totalFloorAreaTsubo?.toLocaleString() ?? '\xa0'.repeat(9)}
                      >
                        {buildingInfo.totalFloorAreaTsubo?.toLocaleString() ?? '\xa0'.repeat(9)}坪
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        {' '}
                          -（
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.floorUnderGroundHistory !== null &&
                            buildingInfo.floorUnderGroundHistory !== undefined &&
                            buildingInfo.floorUnderGround !== buildingInfo.floorUnderGroundHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {buildingInfo.floorUnderGround ?? '\xa0'.repeat(6)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        /
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.floorGroundHistory !== null &&
                            buildingInfo.floorGroundHistory !== undefined &&
                            buildingInfo.floorGround !== buildingInfo.floorGroundHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {buildingInfo.floorGround ?? '\xa0'.repeat(6)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        /
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        {buildingInfo.floorPenthouse ?? '\xa0'.repeat(6)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        ）
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={5}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <>
                        <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                          設備工事:{' '}
                          {codeNamesPresence(
                            buildingInfo?.buildingServicesWorkFlg?.toString()
                          ) ?? '\xa0'.repeat(6)}
                        </span>
                        <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                          {' '}
                          杭打:
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            color:
                              updStsKbn === '2' &&
                              buildingInfo.pilingFlgHistory !== null &&
                              buildingInfo.pilingFlgHistory !== undefined &&
                              buildingInfo.pilingFlg !== buildingInfo.pilingFlgHistory
                                ? '#D0611E'
                                : ''
                          }}
                        >
                          {codeNamesPresence(
                            buildingInfo?.pilingFlg?.toString()
                          ) ?? '\xa0'.repeat(6)}
                        </span>
                        <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                          {' '}
                          免震:
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            color:
                              updStsKbn === '2' &&
                              buildingInfo.seismicIsolationFlgHistory !== null &&
                              buildingInfo.seismicIsolationFlgHistory !== undefined &&
                              buildingInfo.seismicIsolationFlg !== buildingInfo.seismicIsolationFlgHistory
                                ? '#D0611E'
                                : ''
                          }}
                        >
                          {codeNamesPresence(
                            buildingInfo?.seismicIsolationFlg?.toString()
                          ) ?? '\xa0'.repeat(6)}
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            color:
                              updStsKbn === '2' &&
                              buildingInfo.downFlgHistory !== null &&
                              buildingInfo.downFlgHistory !== undefined &&
                              buildingInfo.downFlg !== buildingInfo.downFlgHistory
                                ? '#D0611E'
                                : ''
                          }}
                        >
                          {' '}
                          {codeNamesTopdown.find(
                            (codeName) =>
                              codeName.code === buildingInfo?.downFlg?.toString()
                          )?.name ?? '\xa0'.repeat(6)}{' '}
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                          }}
                          title={buildingInfo.specialConstructionMethod ?? ''}
                        >
                          工法: {buildingInfo.specialConstructionMethod}
                        </span>
                      </>
                    </GridLayoutItem>
                    <GridLayoutItem col={1} colSpan={3} row={6}>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.startYmHistory !== null &&
                            buildingInfo.startYmHistory !== undefined &&
                            buildingInfo.startYm !== buildingInfo.startYmHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {(buildingInfo.startYm != null) ? dayjs(buildingInfo.startYm).format('YYYY/MM') : '\xa0'.repeat(6)}{' '}
                      </span>
                      -
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.completionYmHistory !== null &&
                            buildingInfo.completionYmHistory !== undefined &&
                            buildingInfo.completionYm !== buildingInfo.completionYmHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {' '}{(buildingInfo.completionYm != null) ? dayjs(buildingInfo.completionYm).format('YYYY/MM') : '\xa0'.repeat(6)}{' '}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.scheduleHistory !== null &&
                            buildingInfo.scheduleHistory !== undefined &&
                            buildingInfo.schedule !== buildingInfo.scheduleHistory
                              ? '#D0611E'
                              : ''
                        }}
                      >
                        {''} {buildingInfo.schedule ?? '\xa0'.repeat(3)}{' '}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        {' '}
                        ヶ月
                      </span>{' '}
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.siteAreaM2History !== null &&
                            buildingInfo.siteAreaM2History !== undefined &&
                            buildingInfo.siteAreaM2 !== buildingInfo.siteAreaM2History
                              ? '#D0611E'
                              : ''
                        }}
                        title={buildingInfo.siteAreaM2?.toLocaleString() ?? '\xa0'.repeat(9)}
                      >
                        {buildingInfo.siteAreaM2?.toLocaleString() ?? '\xa0'.repeat(9)}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        ㎡/
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          color:
                            updStsKbn === '2' &&
                            buildingInfo.siteAreaTsuboHistory !== null &&
                            buildingInfo.siteAreaTsuboHistory !== undefined &&
                            buildingInfo.siteAreaTsubo !== buildingInfo.siteAreaTsuboHistory
                              ? '#D0611E'
                              : ''
                        }}
                        title={buildingInfo.siteAreaTsubo?.toLocaleString() ?? '\xa0'.repeat(9)}
                      >
                        {buildingInfo.siteAreaTsubo?.toLocaleString() ?? '\xa0'.repeat(9)}坪
                      </span>
                    </GridLayoutItem>
                  </>

                  <GridLayoutItem
                    col={1}
                    colSpan={3}
                    row={7}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                      title={buildingInfo.remark ?? '\xa0'.repeat(3)}
                    >
                      {' '}
                      備考： {buildingInfo.remark ?? '\xa0'.repeat(3)}{' '}
                    </span>
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>

              <GridLayoutItem col={3}>
                <GridLayout
                  gap={{ cols: 1 }}
                  rows={[
                    { height: '1.0em' },
                    { height: '1.0em' },
                    { height: '1.0em' },
                    { height: '1.0em' },
                    { height: '1.0em' },
                    { height: '1.0em' }
                  ]}
                >
                  <GridLayoutItem col={1} row={1}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>工事部</span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={1}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.constructionSectionNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.constructionSectionNm ?? '\xa0'.repeat(6)}
                    </span>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>
                      ）{' '}
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.chiefPersonNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.chiefPersonNm ?? '\xa0'.repeat(6)}{' '}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={2}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.chiefPersonContacts ?? ''}
                    >
                      {buildingInfo.chiefPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={3}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>本社営業部</span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={3}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.hqSalesSectionNm ?? '\xa0'.repeat(6)}
                    >
                      {' '}{buildingInfo.hqSalesSectionNm ?? '\xa0'.repeat(6)}
                    </span>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>
                      ）
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.hqSalesPersonNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.hqSalesPersonNm ?? '\xa0'.repeat(6)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={4}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                    >
                      {' '}
                      {buildingInfo.hqSalesPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={5}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>支店営業部</span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={5}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.branchSalesSectionNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.branchSalesSectionNm ?? '\xa0'.repeat(6)}
                    </span>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>
                      ）{' '}
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.branchSalesPersonNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.branchSalesPersonNm ?? '\xa0'.repeat(6)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={6}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.branchSalesPersonContacts ?? ''}
                    >
                      {' '}
                      {buildingInfo.branchSalesPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={7}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>発注者</span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={7}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.customerNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.customerNm ?? '\xa0'.repeat(6)}
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.collabCustomerNm ?? '\xa0'.repeat(6)}
                    >
                      {buildingInfo.collabCustomerNm ?? '\xa0'.repeat(6)}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={8}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>設計</span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={8}>
                    <span style={{ fontSize: '0.8em', verticalAlign: 'top' }}>
                      {buildingInfo.designKbn}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={9}
                    style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '0.8em',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        verticalAlign: 'top'
                      }}
                      title={buildingInfo.designerNm ?? ''}
                    >
                      {buildingInfo.designerNm}
                    </span>
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>
            </GridLayout>
          </CardBody>
        </Card>
      </Tooltip>
    </div>
  )
})
